import React from 'react';
import styled from 'styled-components';
import {GetCardTypeForBody} from '../../../../../util/utils';
import PrintViewKnowledgeDescription from './PrintViewKnowledgeDescription';

function PrintViewUserLookupBody(props) {
	const {body} = props;

	const formBodyBorder = GetCardTypeForBody(body);

	return (
		<StyledPrintViewUserLookupBody className={`StyledPrintViewUserLookupBody ${formBodyBorder}`}>
			{body && body.id > 0 && <PrintViewKnowledgeDescription body={body} bodyDescription={body.name} />}
			<section className="SectionBodyData PrintViewUserLookupBodyData" id={body.id}>
				<section className="printUserLookup">{body.bodyFreeText}</section>
			</section>
		</StyledPrintViewUserLookupBody>
	);
}

export default PrintViewUserLookupBody;

const StyledPrintViewUserLookupBody = styled.section`
	.SectionBodyData {
		margin-top: var(--px-10);
		display: block !important;
	}
	.printUserLookup {
		border: var(--px-1) solid var(--neutrals-300) !important;
		max-width: var(--px-300);
		padding: var(--px-1) var(--px-6);
		margin-top: var(--px-5);
	}
`;
